// ink-component
import React, { useContext, useState, useEffect, useRef } from 'react';
import { SideNavContext } from '../../SideNavContext';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { StyledSideNavGroup } from './styles';

export type SideNavGroupProps = React.HTMLAttributes<HTMLLIElement>;

/**
 * @purpose Navigation list item group element (li)
 * @group SideNav
 * @categories navigation
 * @HTMLType HTMLLIElement
 */
const SideNavGroup = (props: SideNavGroupProps) => {
  const { className, style, ...otherProps } = props;
  const { isClosed } = useContext(SideNavContext);
  const globalProps = getGlobalProps({});

  // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
  const ref = useRef<null | HTMLLIElement>(null);

  const [groupHighlighted, setGroupHighlighted] = useState(false);

  useEffect(() => {
    const highlightTimer = setTimeout(() => {
      if (groupHighlighted) {
        setGroupHighlighted(false);
      }
    }, 950);

    return () => {
      clearTimeout(highlightTimer);
    };
  }, [groupHighlighted]);

  useEffect(() => {
    const scrollTimer = setTimeout(() => {
      if (groupHighlighted) {
        ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 200);

    return () => {
      clearTimeout(scrollTimer);
    };
  }, [groupHighlighted]);

  const handleClick = () => {
    if (isClosed) {
      setGroupHighlighted(true);
    }
  };

  return (
    <StyledSideNavGroup
      ref={ref}
      onClick={handleClick}
      highlighted={groupHighlighted}
      isClosed={isClosed}
      {...otherProps}
      {...globalProps}
    />
  );
};

SideNavGroup.displayName = 'SideNav.Group';

export default SideNavGroup;
